import Resource from './Resource';

/**
 * Booking Resource
 */
class Booking extends Resource
{
    constructor() {
        super('booking', ['bookings']);
    }

    search(query, params = {}, config = {}) {
      params = Object.assign(params, { query });

      return this._doGet(['search'], params, config);
    }

    options(params) {
        return this._doGet(['options'], params);
    }

    invoice(id, params = {}) {
      return this._doGet([id, 'invoice'], params);
    }

    assign(id, assignee_id, params = {}) {
        return this._doPost([id, 'assign'], { assignee_id}, params);
    }
}   

export let BookingResource = new Booking();

/**
 * Booking Schema
 * @param {Object} defaults [description]
 */
export let BookingSchema = function(defaults = {}) {
    let schema = {
        team_id: null,
        team: null,
        contact_id: null,
        contact: null,
        invoice_id: null,
        invoice: null,
        quote_id: null,
        quote: null,
        instance_id: null,
        instance: null,
        advisories: [],
        vehicle_presence_status: 'customer',
        vehicle_key_number: null,
        requires_courtesy_car: false,
        assignee_id: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export let BookingPresenceStatuses = {
    ON_SITE: 'on_site',
    CUSTOMER: 'customer',
    SUPPLIER: 'supplier'
}

export let BookingPresenceStatusList = [
    {
        label: 'On-Site',
        value: BookingPresenceStatuses.ON_SITE,
    },{
        label: 'With Customer',
        value: BookingPresenceStatuses.CUSTOMER,
    },{
        label: 'With Supplier',
        value: BookingPresenceStatuses.SUPPLIER,
    },
]